import { SET_REDIRECT_ROUTE, RESET_REDIRECT_ROUTE } from "./RouterActionTypes";

const mutations = {
	[SET_REDIRECT_ROUTE]: (state, route) =>
	{
		state.redirectRoute = route;
	},
	[RESET_REDIRECT_ROUTE]: (state) =>
	{
		state.redirectRoute = null;
	},
};

export default { mutations };